import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { EmailTypeService } from "@/services/emailType";
import { EmailTypeRole } from "@/types/emailType";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";

export const useEmailTypeAvailableRolesQuery = ({
  emailTypeId,
  enabled = true,
  name = "emailTypeAvailableRoles",
}: {
  emailTypeId: string;
  enabled?: boolean;
  name?: string;
}) => {
  const options = useCreateDataTableOptions<EmailTypeRole>(name);
  const queryKeyBase = [name, emailTypeId];
  const queryKey = useDynamicQueryParams(queryKeyBase, options);

  const query = useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) =>
      EmailTypeService.getAvailableRoles(emailTypeId, {
        lastItem: pageParam,
        filters: options.filters,
        sorting: options.sorting[0],
      }),
    initialPageParam: undefined,
    getNextPageParam: ({ last_item }) => last_item,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled,
  });

  return {
    query,
    options,
    queryKey,
  };
};
